import { notifications } from "@mantine/notifications";
import { getNotificationIcon, NotificationType } from "./NotificationIcon";
import { useDeviceStore } from "shared/stores/deviceStore";

const notificationDefaults: Record<
  NotificationType,
  { title: string; message: string; color: string }
> = {
  error: {
    title: "Something went wrong",
    message: "Please try again.",
    color: "#F9D5E7",
  },
  success: {
    title: "Success!",
    message: "Your request was completed successfully.",
    color: "#B5E2E0",
  },
  warning: {
    title: "Warning",
    message: "Please check your input.",
    color: "#FCE69C",
  },
  info: {
    title: "Information",
    message: "Your session will expire soon.",
    color: "#BDE0FE",
  },
};

export const showNotification = ({
  type,
  title,
  message,
  textColor = "#13141C",
}: {
  type: NotificationType;
  title?: string;
  message?: string;
  textColor?: string;
}) => {
  const defaultValues = notificationDefaults[type];
  const isMobile = useDeviceStore.getState().isMobile;

  notifications.show({
    title: title || defaultValues.title,
    message: message || defaultValues.message,
    color: defaultValues.color,
    icon: getNotificationIcon(type),
    position: isMobile ? "bottom-center" : "top-right",
    closeButtonProps: { iconSize: 22 },

    styles: {
      title: { fontSize: "1.2rem", color: textColor, fontWeight: "700" },
      description: { fontSize: "1.2rem", color: textColor },
      root: {
        backgroundColor: defaultValues.color,
        padding: "1rem",
        bottom: isMobile ? 80 : 0,
        pointerEvents: "none",
      },
      closeButton: {
        pointerEvents: "auto",
        backgroundColor: "transparent",
        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
        "&:active": { backgroundColor: "rgba(0, 0, 0, 0.2)" },
      },
    },
    radius: "lg",
  });
};
